export const normalizeValidationErrors = (errors) => {
  if (!errors || typeof errors !== 'object') return null;

  return Object.keys(errors).reduce((acc, key) => {
    acc[key] = errors[key]?.[0];
    return acc;
  }, {});
};
